export type OETExportBrowser = 'chrome' | 'firefox' | 'other';

export function detectOETExportBrowser(userAgent?: string): OETExportBrowser {
  const ua =
    userAgent ??
    (typeof navigator !== 'undefined' ? navigator.userAgent : '');

  if (/firefox\//i.test(ua)) {
    return 'firefox';
  }

  if (/(chrome|crios)\//i.test(ua) && !/(edg|opr|opera)\//i.test(ua)) {
    return 'chrome';
  }

  return 'other';
}
